(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jargon-card-explainer"] && !Shopify.designMode) return;
  try {
    
(function () {

  var DURATIONS = [10000, 12000, 7000];
  var REVEAL_AT = 7000; // ms into "Test it" before the definition is shown automatically
  var PARTS = ['category', 'term', 'illustration', 'core', 'example'];

  function initExplainer(root) {
    if (!root || root.getAttribute('data-jx-ready') === 'true') return;
    root.setAttribute('data-jx-ready', 'true');

    function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    var steps = all('[data-jx-step]');
    var fills = all('.jx-step-fill');
    var panels = all('[data-jx-panel]');
    var partButtons = all('.jx-part');
    var frontHighlights = all('.jx-front .jx-hl');
    var hoverZones = all('[data-jx-hover]');
    var scene = root.querySelector('.jx-scene');
    var toggle = root.querySelector('[data-jx-toggle]');
    var revealBtn = root.querySelector('[data-jx-reveal]');
    var revealLabel = root.querySelector('[data-jx-reveal-label]');
    var statusEl = root.querySelector('[data-jx-status]');

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var step = 0;
    var elapsed = 0;
    var last = null;
    var userPaused = reduceMotion; // no autoplay for "reduce motion" users
    var manual = reduceMotion;     // true after the visitor took control
    var hovering = false;
    var inView = false;
    var hoverPart = null;
    var activePart = undefined;
    var rafId = null;
    var revealed = false;

    function running() { return !userPaused && !hovering && inView; }

    function setPart(key) {
      if (key === activePart) return;
      activePart = key;
      frontHighlights.forEach(function (h) { h.classList.toggle('is-on', h.getAttribute('data-jx-part') === key); });
      partButtons.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-jx-part') === key); });
    }

    function setRevealed(value) {
      revealed = value;
      root.classList.toggle('is-revealed', value);
      if (revealBtn) {
        revealBtn.setAttribute('aria-pressed', value ? 'true' : 'false');
        revealLabel.textContent = revealBtn.getAttribute(value ? 'data-hide-text' : 'data-reveal-text');
      }
      if (statusEl) statusEl.textContent = value ? statusEl.getAttribute('data-text') : '';
    }

    function paint() {
      var progress = manual ? 1 : Math.min(elapsed / DURATIONS[step], 1);
      fills.forEach(function (f, i) {
        var v = i < step ? 1 : (i === step ? progress : 0);
        f.style.transform = 'scaleX(' + v + ')';
      });
      if (step === 0) {
        var auto = manual ? null : PARTS[Math.min(PARTS.length - 1, Math.floor(progress * PARTS.length))];
        setPart(hoverPart || auto);
      } else {
        setPart(null);
      }
      if (step === 1 && !manual) {
        var shouldReveal = elapsed >= REVEAL_AT;
        if (shouldReveal !== revealed) setRevealed(shouldReveal);
      }
    }

    function goTo(index) {
      step = index;
      elapsed = 0;
      setRevealed(false);
      root.setAttribute('data-step', String(index));
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        s.classList.toggle('is-done', i < index);
        if (i === index) { s.setAttribute('aria-current', 'step'); } else { s.removeAttribute('aria-current'); }
      });
      panels.forEach(function (p, i) {
        var active = i === index;
        p.classList.toggle('is-active', active);
        if (active) { p.removeAttribute('aria-hidden'); } else { p.setAttribute('aria-hidden', 'true'); }
      });
      paint();
    }

    function frame(t) {
      rafId = null;
      if (running()) {
        if (last !== null) elapsed += t - last;
        last = t;
        if (elapsed >= DURATIONS[step]) goTo((step + 1) % DURATIONS.length);
      } else {
        last = null;
      }
      paint();
      if (inView) rafId = window.requestAnimationFrame(frame);
    }

    function startLoop() {
      if (!rafId) rafId = window.requestAnimationFrame(frame);
    }

    function setPaused(paused) {
      userPaused = paused;
      if (!paused) { manual = false; }
      last = null;
      toggle.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-label', paused ? 'Play animation' : 'Pause animation');
      paint();
    }

    function userGoTo(index) {
      setPaused(true);
      manual = true;
      goTo(index);
    }

    steps.forEach(function (s) {
      s.addEventListener('click', function () {
        userGoTo(parseInt(s.getAttribute('data-jx-step'), 10));
      });
    });

    function userReveal() {
      setPaused(true);
      manual = true;
      setRevealed(!revealed);
      paint();
    }

    // In "Test it" the card reveals the answer; otherwise it moves to the next step
    function onCard() {
      if (step === 1) { userReveal(); } else { userGoTo((step + 1) % DURATIONS.length); }
    }

    scene.addEventListener('click', onCard);
    scene.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onCard();
      }
    });

    if (revealBtn) revealBtn.addEventListener('click', function () {
      if (step === 1) userReveal();
    });

    toggle.addEventListener('click', function () { setPaused(!userPaused); });

    // Hovering a card part (or focusing it) shows it on the card
    partButtons.forEach(function (b) {
      function on() { hoverPart = b.getAttribute('data-jx-part'); paint(); }
      function off() { hoverPart = null; paint(); }
      b.addEventListener('mouseenter', on);
      b.addEventListener('focus', on);
      b.addEventListener('mouseleave', off);
      b.addEventListener('blur', off);
    });

    // Learning phases: hover or focus a phase to read its description
    var phaseItems = all('[data-jx-phase]');
    var phaseDesc = root.querySelector('[data-jx-phase-desc]');
    var currentPhase = root.querySelector('.jx-phasebar-item.is-current');
    function showPhase(item) {
      if (!item || !phaseDesc) return;
      phaseItems.forEach(function (p) { p.classList.toggle('is-shown', p === item); });
      phaseDesc.textContent = item.getAttribute('data-desc');
    }
    phaseItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () { showPhase(item); });
      item.addEventListener('focus', function () { showPhase(item); });
      item.addEventListener('mouseleave', function () { showPhase(currentPhase); });
      item.addEventListener('blur', function () { showPhase(currentPhase); });
    });

    // Pause while the visitor is looking at the card or the list
    hoverZones.forEach(function (z) {
      z.addEventListener('mouseenter', function () { hovering = true; });
      z.addEventListener('mouseleave', function () { hovering = false; });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) { startLoop(); } else { last = null; }
      }, { threshold: 0.35 });
      io.observe(root);
    } else {
      inView = true;
      startLoop();
    }

    if (userPaused) setPaused(true);
    goTo(0);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-jx]'), initExplainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-jx]');
    if (root) initExplainer(root);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jargon-hero-3"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initHero(root) {
    if (!root || root.getAttribute('data-jh-ready') === 'true') return;
    root.setAttribute('data-jh-ready', 'true');

    function q(name) { return root.querySelector('[data-jh="' + name + '"]'); }
    function qa(name) { return root.querySelectorAll('[data-jh="' + name + '"]'); }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = window.matchMedia('(hover: none)').matches;

    /* ---------- Cards ---------- */

    var scene = q('scene');
    var cardsEl = q('cards');
    var cards = [];
    if (cardsEl) {
      try { cards = JSON.parse(cardsEl.textContent); } catch (err) { cards = []; }
    }

    if (scene && cards.length) {
      var tilt = q('tilt');
      var frontImg = q('front');
      var backImg = q('back');
      var frontPh = q('frontph');
      var backPh = q('backph');
      var flipLabel = q('fliplabel');
      var hint = q('hint');
      var tabs = qa('tab');
      var stack = root.querySelector('.jargon-card-stack');
      var prevBtn = q('prev');
      var nextBtn = q('next');

      var flipText = touch ? 'Tap to flip' : 'Click to flip';
      var flipBackText = touch ? '← Tap to flip back' : '← Flip back  ·  use arrows to browse';

      var current = 0;
      var flipped = false;
      var interacted = false;

      flipLabel.textContent = flipText;

      // Preload all card images so switching doesn't flash
      cards.forEach(function (c) {
        [c.front, c.back].forEach(function (src) {
          if (src) { var img = new Image(); img.src = src; }
        });
      });

      function setFace(img, ph, src, term, side) {
        if (src) {
          img.src = src;
          img.alt = (term || 'JARGON card') + ' — ' + side;
          img.hidden = false;
          ph.hidden = true;
        } else {
          img.hidden = true;
          ph.hidden = false;
          ph.querySelector('span').textContent = term || '';
        }
      }

      function render(idx) {
        var c = cards[idx] || {};
        setFace(frontImg, frontPh, c.front, c.term, 'front');
        setFace(backImg, backPh, c.back, c.term, 'back');
        Array.prototype.forEach.call(tabs, function (t, i) {
          var active = i === idx;
          t.classList.toggle('is-active', active);
          t.classList.toggle('is-filled', i <= idx);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        // Stacked cards behind take the colors of the next phases
        var n = cards.length;
        var next1 = cards[(idx + 1) % n] || {};
        var next2 = cards[(idx + 2) % n] || {};
        if (n > 1 && next1.color) stack.style.setProperty('--jh-ghost-1', next1.color);
        if (n > 2 && next2.color) stack.style.setProperty('--jh-ghost-2', next2.color);
        scene.setAttribute('aria-label', 'Flip card: ' + (c.term || 'card'));
      }

      function setFlipped(state) {
        flipped = state;
        scene.classList.toggle('is-flipped', flipped);
        scene.setAttribute('aria-pressed', flipped ? 'true' : 'false');
        flipLabel.textContent = flipped ? flipBackText : flipText;
        if (hint) hint.classList.toggle('is-hidden', flipped);
      }

      function goTo(idx) {
        current = (idx + cards.length) % cards.length;
        setFlipped(false);
        scene.classList.remove('is-entering');
        void scene.offsetWidth; // restart the entry animation
        scene.classList.add('is-entering');
        render(current);
      }

      function userAction(fn) {
        return function (e) {
          interacted = true;
          fn(e);
        };
      }

      scene.addEventListener('click', userAction(function () { setFlipped(!flipped); }));

      scene.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          interacted = true;
          setFlipped(!flipped);
        } else if (e.key === 'ArrowRight') {
          interacted = true;
          goTo(current + 1);
        } else if (e.key === 'ArrowLeft') {
          interacted = true;
          goTo(current - 1);
        }
      });

      if (prevBtn) prevBtn.addEventListener('click', userAction(function () { goTo(current - 1); }));
      if (nextBtn) nextBtn.addEventListener('click', userAction(function () { goTo(current + 1); }));

      Array.prototype.forEach.call(tabs, function (t) {
        t.addEventListener('click', userAction(function () {
          goTo(parseInt(t.getAttribute('data-index'), 10));
        }));
      });

      // Expose for theme editor block selection
      root._jhGoTo = goTo;

      // 3D tilt (desktop, mouse only)
      if (root.getAttribute('data-tilt') === 'true' && !reduceMotion &&
          window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        scene.addEventListener('mousemove', function (e) {
          var r = scene.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          tilt.style.setProperty('--jh-ry', (x * 10).toFixed(2) + 'deg');
          tilt.style.setProperty('--jh-rx', (-y * 8).toFixed(2) + 'deg');
        });
        scene.addEventListener('mouseleave', function () {
          tilt.style.setProperty('--jh-ry', '0deg');
          tilt.style.setProperty('--jh-rx', '0deg');
        });
      }

      // Flip the first card once, only when visible and untouched
      if (root.getAttribute('data-auto-flip') === 'true' && !reduceMotion && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          setTimeout(function () {
            if (interacted) return;
            setFlipped(true);
            setTimeout(function () {
              if (!interacted) setFlipped(false);
            }, 2200);
          }, 3000);
        }, { threshold: 0.6 });
        io.observe(scene);
      }

      render(0);
    }

    /* ---------- Popup ---------- */

    var overlay = q('overlay');
    if (!overlay) return;

    var form = q('form');
    var emailInput = q('email');
    var submitBtn = q('submit');
    var submitLabel = q('submitlabel');
    var spinner = q('spinner');
    var errorMsg = q('error');
    var defaultState = q('default');
    var successState = q('success');
    var closeBtn = q('close');
    var lastTrigger = null;
    var closeTimer = null;

    // Move the popup to <body> so no parent transform/overflow can clip it
    document.body.appendChild(overlay);

    function setLoading(loading) {
      submitBtn.disabled = loading;
      submitLabel.hidden = loading;
      spinner.hidden = !loading;
    }

    function showError(msg) {
      errorMsg.textContent = msg;
      errorMsg.hidden = false;
    }

    function resetPopup() {
      defaultState.hidden = false;
      successState.hidden = true;
      form.reset();
      errorMsg.hidden = true;
      setLoading(false);
    }

    function openPopup(e) {
      lastTrigger = e && e.currentTarget ? e.currentTarget : null;
      clearTimeout(closeTimer);
      resetPopup();
      overlay.hidden = false;
      document.documentElement.setAttribute('scroll-lock', '');
      setTimeout(function () { emailInput.focus(); }, 60);
    }

    function closePopup() {
      if (overlay.hidden) return;
      clearTimeout(closeTimer);
      overlay.hidden = true;
      document.documentElement.removeAttribute('scroll-lock');
      if (lastTrigger) lastTrigger.focus();
    }

    function visibleFocusables() {
      return Array.prototype.filter.call(
        overlay.querySelectorAll('button:not([disabled]), input:not([disabled])'),
        function (el) { return el.offsetParent !== null; }
      );
    }

        Array.prototype.forEach.call(qa('open'), function (btn) {
      btn.addEventListener('click', openPopup);
    });

    // Other sections (and the header) can open this popup via [data-jargon-waitlist]
    window.jargonOpenWaitlist = function (trigger) {
      openPopup({ currentTarget: trigger || null });
    };
    if (!window.jargonWaitlistBound) {
      window.jargonWaitlistBound = true;
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest ? e.target.closest('[data-jargon-waitlist]') : null;
        if (!trigger || typeof window.jargonOpenWaitlist !== 'function') return;
        e.preventDefault();
        window.jargonOpenWaitlist(trigger);
      });
    }

    closeBtn.addEventListener('click', closePopup);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePopup(); return; }
      if (e.key !== 'Tab') return;
      var f = visibleFocusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError('Please enter a valid email address.');
        return;
      }
      errorMsg.hidden = true;
      setLoading(true);

      // Klaviyo Client API — Create Client Subscription. Success = HTTP 202.
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.getAttribute('data-company-id')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website waitlist',
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: root.getAttribute('data-list-id') } }
            }
          }
        })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Subscribe error: ' + res.status);
        defaultState.hidden = true;
        successState.hidden = false;
        setLoading(false);
        closeBtn.focus();
        closeTimer = setTimeout(closePopup, 3500);
      })
      .catch(function (err) {
        console.error('Klaviyo error:', err);
        showError('Something went wrong. Please try again.');
        setLoading(false);
      });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-jargon-hero]'), initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init after a section re-renders
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-jargon-hero]');
    if (root) initHero(root);
  });

  // Theme editor: selecting a card block shows that card
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('[data-jargon-hero]') : null;
    if (!root || !root._jhGoTo) return;
    var idx = parseInt(e.target.getAttribute('data-index'), 10);
    if (!isNaN(idx)) root._jhGoTo(idx);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
